<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { ToastProvider } from '@kori/ui'
import ImpersonationBanner from '@/components/platform/ImpersonationBanner.vue'
import StepUpModal from '@/components/StepUpModal.vue'
import { useImpersonationStore } from '@/stores/impersonation'
import { useIdleSignOut } from '@/composables/useIdleSignOut'

// S-SUP-050: re-seed the impersonation banner if the server still has a live
// session for this caller (e.g. the user hit refresh during a session).
const impersonation = useImpersonationStore()
onMounted(() => {
  void impersonation.hydrate()
})

// Sign out after the school's inactivity limit (30 minutes by default).
useIdleSignOut()
</script>

<template>
  <div class="min-h-screen flex flex-col bg-surface-canvas text-ink-primary">
    <!-- S-SUP-050: persistent non-dismissible banner when impersonating. -->
    <ImpersonationBanner />
    <RouterView v-slot="{ Component, route }">
      <transition name="fade" mode="out-in">
        <component :is="Component" :key="route.fullPath" />
      </transition>
    </RouterView>
    <ToastProvider />
    <!-- Singleton step-up challenge modal — driven by useStepUp(). -->
    <StepUpModal />
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
